import React, { useEffect } from "react"
import { observer } from "mobx-react-lite"
import { ScheduleListElement, ScheduleListSkeleton } from "entities/schedule"
import { ScheduleEventStore } from "../../app/store"
import { ResultWrapper } from "../../entities/resultWrapper"

// ----------------------------------------------------------------------

export const ScheduleList = observer(function ScheduleList() {
  const { scheduleEvents, load, isLoading, error } = ScheduleEventStore

  useEffect(() => {
    void load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ResultWrapper
      error={error}
      isLoading={isLoading}
      loadingComponent={ScheduleListSkeleton}
      isEmpty={!scheduleEvents.length}
    >
      {scheduleEvents.map((scheduleEvent) => (
          <ScheduleListElement key={scheduleEvent._id} {...scheduleEvent}/>
        ),
      )}
    </ResultWrapper>
  )
})

